// Item workflow statuses
export enum ConceptLinkerValidatorItemStatus {
  PENDING = 0,
  NEEDS_USER_REVIEW = 1,
  DONE = 2,
}

// Review statuses
export enum ConceptLinkerValidatorStatus {
  PENDING = 3,
  NEEDS_USER_REVIEW = 5,
  DONE = 6,
}

// Async task status values (matching backend AsyncTasksQueue constants)
export enum AsyncTaskStatus {
  PENDING = 0,
  DOING = 1,
  DONE = 2,
  FAILED = 3,
  DEAD_LETTER = 4,
  CANCELLED = 5,
  AWAITING_MEMORY = 6,
  SKIPPED = 7,
}

export const ConceptLinkerValidatorStatusLabels: Record<ConceptLinkerValidatorStatus, string> = {
  [ConceptLinkerValidatorStatus.PENDING]: 'pending',
  [ConceptLinkerValidatorStatus.NEEDS_USER_REVIEW]: 'needs_user_review',
  [ConceptLinkerValidatorStatus.DONE]: 'done',
};

export const ConceptLinkerValidatorItemStatusLabels: Record<ConceptLinkerValidatorItemStatus, string> = {
  [ConceptLinkerValidatorItemStatus.PENDING]: 'pending',
  [ConceptLinkerValidatorItemStatus.NEEDS_USER_REVIEW]: 'needs_user_review',
  [ConceptLinkerValidatorItemStatus.DONE]: 'done',
};

export function getStatusLabel(status: ConceptLinkerValidatorStatus): string {
  return ConceptLinkerValidatorStatusLabels[status] || 'unknown';
}
